import React from "react"
import { useSelector } from "react-redux"

import AddressCard from "./addressCard"


const BillingAddressCards = (props) => {

    const { billingAddresses, selectedAddressId, handleBillingAddress, disabled, showLedgerName, readOnly } = props 
    const states = useSelector(state => state.common.states)

    const handleAddressSelection = (id) => {
        handleBillingAddress(id)
    }

    let updatedBillAddresses = billingAddresses.map(eachBillAddr => {
        const stateDetails = states.find(eachState => eachState.stateId === eachBillAddr.stateId)
        return {...eachBillAddr, stateName: stateDetails?.stateName}
    })

    updatedBillAddresses.sort((a, b) => {
        const stateComparison = a.stateName?.localeCompare(b.stateName)
    
        if (stateComparison === 0) {
          return a?.loc?.localeCompare(b?.loc)
        }
      
        return stateComparison
    })

    const sellectedBillAddr = updatedBillAddresses?.find(eachBillAddr => eachBillAddr.billAddrId === selectedAddressId)

    // console.log("sellectedBillAddr",selectedAddressId, sellectedBillAddr)

    let waterMark = ''
    if(sellectedBillAddr){
        if(sellectedBillAddr.gstinCode === "URD"){
            waterMark = 'urd-watermark'
        }
        else if(sellectedBillAddr.companyGSTIN && sellectedBillAddr.companyGSTIN.statusId === 20){
            waterMark = 'blacklisted-watermark'
        }   
        else if(sellectedBillAddr.companyGSTIN && [21, 22].includes(sellectedBillAddr.companyGSTIN.statusId)){
            waterMark = 'vp-on-hold-watermark'
        }
    }
    
    return(
        <div className='post-req-shipping-component'>
            {sellectedBillAddr ?
                <AddressCard 
                    id={null} 
                    gstinTradeName={sellectedBillAddr?.gstinTradeName}
                    address={sellectedBillAddr?.billAddress} 
                    city={sellectedBillAddr?.loc} 
                    stateName={sellectedBillAddr.stateName} 
                    gstinCode={sellectedBillAddr?.gstinCode} 
                    pinCode={sellectedBillAddr?.pinCode}
                    buttonLabel={"UNSELECT"} 
                    handleAddressSelection={handleAddressSelection} 
                    className="selected-btn" 
                    disabled={disabled}
                    waterMark={waterMark}
                    ledgerName={sellectedBillAddr?.ledgerName}
                    showLedgerName={showLedgerName}
                    readOnly={readOnly}
                />
                :
                <>
                    {updatedBillAddresses.map(eachBillAddr =>{
                        let waterMark = ''
                        if (eachBillAddr.gstinCode === "URD") {
                            waterMark = 'urd-watermark'
                        }
                        else if (eachBillAddr.companyGSTIN && eachBillAddr.companyGSTIN.statusId === 20) {
                            waterMark = 'blacklisted-watermark'
                        }
                        else if (eachBillAddr.companyGSTIN && [21, 22].includes(eachBillAddr.companyGSTIN.statusId)) {
                            waterMark = 'vp-on-hold-watermark'
                        }

                        return (
                            <AddressCard 
                                key={`billingAddress-${eachBillAddr.billAddrId}`} 
                                id={eachBillAddr.billAddrId} 
                                address={eachBillAddr.billAddress}
                                gstinTradeName={eachBillAddr?.gstinTradeName}
                                city={eachBillAddr?.loc} 
                                stateName={eachBillAddr.stateName} 
                                gstinCode={eachBillAddr.gstinCode} 
                                pinCode={eachBillAddr.pinCode}
                                buttonLabel={"SELECT"} 
                                handleAddressSelection={handleAddressSelection} 
                                disabled={disabled}
                                waterMark={waterMark}
                                ledgerName={eachBillAddr.ledgerName}
                                showLedgerName={showLedgerName}
                                readOnly={readOnly}
                            />
                        )
                    })}
                </>
            }
        </div>
    )

}

export default BillingAddressCards